export default __webpack_public_path__ + "static/media/qr-code.3c9e2b1e.png";